import type { PurchaserPortalKey } from "@src/domain/entities/purchaser";
import type { IPurchaserRepository } from "@src/domain/repositories/purchaser";

export class GetPurchaserPortalKeysUseCase {
  private readonly purchaserRepository: IPurchaserRepository;

  constructor(purchaserRepository: IPurchaserRepository) {
    this.purchaserRepository = purchaserRepository;
  }

  execute(purchaserId: number): Promise<PurchaserPortalKey[]> {
    return this.purchaserRepository.getPurchaserPortalKeys(purchaserId);
  }
}
